/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import fondo from '../../Recursos/fondo_secciones.svg'
import fondo_cell from '../../Recursos/fondo_secciones_cell.svg'
import fondo_peq from '../../Recursos/fondo_secciones_peq.svg'
import Home_Marcas from "./Componentes/Home_Marcas";
import Home_Banners_Peq from "./Componentes/Home_Banners_Peq";
import Home_Mas_Vendidos from "./Componentes/Home_Mas_Vendidos";
import Home_Por_Tipo from "./Componentes/Home_Por_Tipo";
import Home_Por_Categoria from "./Componentes/Home_Por_Categoria";
import Home_Oferta_Tiempo from "./Componentes/Home_Oferta_Tiempo";
import Testimonios from "./Componentes/Testimonios";
import Galleria from "./Componentes/Galleria";
import Home_Articulos from "./Componentes/Home_Articulos";
import {SECCIONES} from "../../Constantes";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Seccion_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#EDFCF6'}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0, zIndex: 1}}>
                <Home_Portada/>
            </Grid>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundImage: `url(${sCell ? fondo_cell : fondo})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    py: 10,
                    mt: sCell ? -6 : -10,
                    zIndex: 2
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Home_Marcas/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 10}}>
                    <Home_Banners_Peq/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                    <Home_Mas_Vendidos/>
                </Grid>


            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 7, mb: 18}}>
                <Home_Por_Tipo/>
            </Grid>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundImage: `url(${fondo})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    py: 10,
                    mt: -4,
                    zIndex: 2
                }}
            >

                <Grid
                    id={SECCIONES[0]}
                    container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Home_Por_Categoria/>
                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 7, mb: 18}}>
                <Home_Oferta_Tiempo/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundImage: `url(${fondo_peq})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    py: 10,
                    mt: -4,
                    zIndex: 2
                }}
            >

                <Grid id={SECCIONES[1]} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Testimonios/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                    <Galleria/>
                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 7, mb: 18}}>
                <Home_Articulos/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Home  